import ttiPolyfill from 'tti-polyfill';

export default function(opts = {}) {
    return ttiPolyfill.getFirstConsistentlyInteractive(opts);
}
